const baseURL = location.origin + location.pathname;

export var DevBaseURL =
  process.env.VUE_APP_Base_URL + "/api/marketingcloud/system";

export function authRouter() {
  location.replace(baseURL);
}
